import { useNavigate } from 'react-router-dom';
import { Box, Button, Drawer } from '@mui/material';
import { Route } from '../../../types/types';
import DrawerContent from './DrawerContent';

import classes from './styles.module.css';
import { useAuthService } from '../../../hooks';

interface Props {
  routes: Route[];
  drawerWidth: number;
  mobileOpen: boolean;
  onDrawerClicked: () => void;
}

const CustomDrawer = ({ routes, drawerWidth, mobileOpen, onDrawerClicked }: Props) => {
  const AuthService = useAuthService();
  const navigate = useNavigate();

  const container = window !== undefined ? () => window.document.body : undefined;

  const handleLogout = async () => {
    try {
      await AuthService.logout();
      navigate('/login');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box
      component='nav'
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label='mailbox folders'
    >
      <Drawer
        container={container}
        variant='temporary'
        color='primary'
        open={mobileOpen}
        onClose={onDrawerClicked}
        ModalProps={{
          keepMounted: true // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth
          }
        }}
      >
        <DrawerContent routes={routes} />
        <Box
          sx={{
            position: 'relative',
            display: 'block',
            height: '100%'
          }}
        >
          <Button
            variant='contained'
            color='error'
            className={classes['logout-button']}
            onClick={handleLogout}
          >
            Cerrar sesión
          </Button>
        </Box>
      </Drawer>
      <Drawer
        variant='permanent'
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth
          }
        }}
        open
      >
        <DrawerContent routes={routes} />
        <Box
          sx={{
            position: 'relative',
            display: 'block',
            height: '100%'
          }}
        >
          <Button
            variant='contained'
            color='error'
            className={classes['logout-button']}
            onClick={handleLogout}
          >
            Cerrar sesión
          </Button>
        </Box>
      </Drawer>
    </Box>
  );
};

export default CustomDrawer;
